import React from 'react';

import formatNumber from 'helpers/formatNumber';
import pluralize from 'helpers/pluralize';

import { DefaultMetaData } from '../EntityMetadata';

const Label: React.FC<any> = (props) => {
  const { entity } = props;
  const { artist_count, grouped_track_count, grouped_album_count } = entity;

  return (
    <DefaultMetaData>
      <span>
        {grouped_track_count > 0
          ? `${formatNumber(grouped_track_count)} ${pluralize(
              'track',
              grouped_track_count
            )}`
          : 'No tracks'}
      </span>
      <span>
        {grouped_album_count > 0
          ? `${formatNumber(grouped_album_count)} ${pluralize(
              'release',
              grouped_album_count
            )}`
          : 'No releases'}
      </span>
      <span>
        {grouped_track_count > 0
          ? `${formatNumber(artist_count)} ${pluralize('artist', artist_count)}`
          : 'No artists'}
      </span>
    </DefaultMetaData>
  );
};
export default Label;
